// @ts-strict-ignore
import React from 'react'
import classNames from 'classnames'
import { removeWhitespaceAndSpecialChars } from '../../helpers/commons'
import { assetsPublicPath } from 'server/helpers/env'

export interface IProviderLogo {
  id: string
  name: string
  images: {
    money: string
    uswitch: string
  }
}

interface IProviderLogoPlatinum {
  name: string
  variant: string
}

const ProviderLogoPlatinum: React.FC<IProviderLogoPlatinum> = ({
  name,
  variant,
}) => {
  // If productData query has failed servers hardcoded main lenders
  const imgAltDesc = 'Mortgage lender'
  const basePath =
    process.env.NODE_ENV === 'development'
      ? `/mortgages/lenders`
      : `${assetsPublicPath}/mortgages/lenders`
  const presetLenderArray = [
    'barclays bank',
    'natwest',
    'santander uk plc',
    'halifax',
    'nationwide bs',
    'leeds bs',
    'newcastle bs',
    'accord',
    'tsb',
    'virgin money',
    'royal bank of scotland'
  ]

  return (
    <div id={removeWhitespaceAndSpecialChars(name)}>
      <div className='ProviderLogoPlatinum'>
        <div className='ProviderLogoPlatinum__photobanner'>
            <>
              {presetLenderArray.map((lenderName, id) => {
                return (
                  <img
                    key={id}
                    className={classNames(
                      'ProviderLogoPlatinum__image ProviderLogoPlatinum__image--desktop',
                      {
                        'ProviderLogoPlatinum__image--ppc': variant === 'ppc',
                      },
                    )}
                    src={`${basePath}/${lenderName}.png`}
                    width={variant === 'cardFinderProviders' ? 84 : variant === 'ppc' ? 150 : 100}
                    alt={name}
                    aria-label={`${imgAltDesc} ${lenderName}`}
                  />
                )
              })}
            </>
        </div>
      </div>
    </div>
  )
}

export default ProviderLogoPlatinum
